import ImageNDC from "../assets/NDC.png";
import ImageS101 from "../assets/空壓機.png";
import ImageS301 from "../assets/空壓機.png";
import ImageS888 from "../assets/空壓機.png";
import ImageNDV22 from "../assets/水冷式真空吸唾機.png";
import ImageNDV33 from "../assets/水冷式真空吸唾機.png";
import ImageSS1A10 from "../assets/水冷式真空吸唾機.png";
import ImageSS1A20 from "../assets/水冷式真空吸唾機.png";
import ImageSS1B10 from "../assets/水冷式真空吸唾機.png";
import ImageSS1B20 from "../assets/水冷式真空吸唾機.png";
import ImageK2 from "../assets/固定式氣冷式真空吸唾機.png";
import ImageS2 from "../assets/移動式氣冷式真空吸唾機.png";
import ImageV4 from "../assets/中央型氣冷式真空吸唾機.png";
import ImageVFD20 from "../assets/變頻水冷式真空吸唾機.png";
import ImageMM10D from "../assets/口外機.png";
import ImageMM05A from "../assets/原創型假牙製作台.png";
import ImageMM05P from "../assets/實用型假牙製作台.png";
import ImageD1 from "../assets/攜帶式D1.png";
import ImageT1 from "../assets/攜帶式T1.png";
import ImageM1 from "../assets/攜帶式M1.png";
import ImageTPRO from "../assets/攜帶式T1.png";

const pictureMapping = {
    "NDCA1": ImageNDC,
    "NDCA2": ImageNDC,
    "NDCA3": ImageNDC,
    "S101": ImageS101,
    "S301": ImageS301,
    "S888": ImageS888,
    "NDV22": ImageNDV22,
    "NDV33": ImageNDV33,
    "SS1A10": ImageSS1A10,
    "SS1A20": ImageSS1A20,
    "SS1B10": ImageSS1B10,
    "SS1B20": ImageSS1B20,
    "K2": ImageK2,
    "S2": ImageS2,
    "V4": ImageV4,
    "VFD20": ImageVFD20,
    "MM10D": ImageMM10D,
    "MM05A": ImageMM05A,
    "MM05P": ImageMM05P,
    "D1": ImageD1,
    "T1": ImageT1,
    "M1": ImageM1,
    "TPRO": ImageTPRO,
};

export default pictureMapping;
